import React from 'react';

interface CardIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const CardIcon: React.FC<CardIconProps> = ({
  width = 16,
  height = 12,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M0 2V3H16V2C16 0.896875 15.1031 0 14 0H2C0.896875 0 0 0.896875 0 2ZM0 4.5V10C0 11.1031 0.896875 12 2 12H14C15.1031 12 16 11.1031 16 10V4.5H0ZM2 9.25C2 8.83438 2.33437 8.5 2.75 8.5H4.25C4.66563 8.5 5 8.83438 5 9.25C5 9.66562 4.66563 10 4.25 10H2.75C2.33437 10 2 9.66562 2 9.25ZM6.5 9.25C6.5 8.83438 6.83437 8.5 7.25 8.5H9.25C9.66562 8.5 10 8.83438 10 9.25C10 9.66562 9.66562 10 9.25 10H7.25C6.83437 10 6.5 9.66562 6.5 9.25Z"
      fill={color}
    />
  </svg>
);

export default CardIcon;
